// import React from "react";
// import bannerBg from "../../images/Restaurant_banner.jpg";
// import { Link } from "react-router-dom";

// const Banner = () => {
//   return (
//     <section
//       className="mahal-banner-section"
//       style={{ backgroundImage: `url(${bannerBg})` }}
//     >
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-lg-7">

//             <div className="mahal-banner-content">

//               <h6 className="mahal-subtitle">FOR RESTAURANTS</h6>

//               <h1 className="mahal-banner-title">
//                 Order Smarter. <br />
//                 <span>Spend Less.</span>
//               </h1>

//               <p className="mahal-banner-desc">
//                 MAHAL is a B2B food sourcing platform that helps restaurants
//                 connect with verified suppliers, manage orders, and control
//                 procurement — all from one place.
//               </p>

//               <div className="mahal-btn-group mt-4">
//                 <Link to="/Registration" className="mahal-btn-primary">
//                   Start Ordering
//                 </Link>

//                 {/* <a
//                   href="/RestaurantLogIn"
//                   className="mahal-btn-outline ms-3  mahal-btn-secondary"
//                 >
//                   Access Your Account
//                 </a> */}
//               </div>

//             </div>

//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Banner;

import React from "react";
import { useTranslation } from "react-i18next";
import bannerBg from "../../images/Restaurant_banner.jpg";
import { Link } from "react-router-dom";

const Banner = () => {
  const { t, i18n } = useTranslation();

  const isArabic = i18n.language === "ar";

  return (
    <section
      className={`mahal-banner-section ${isArabic ? "arabic-banner" : ""}`}
      style={{ backgroundImage: `url(${bannerBg})` }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7">

            <div className="mahal-banner-content">

              <h6 className="mahal-subtitle">
                {t("restaurantbanner.subtitle")}
              </h6>

              <h1 className="mahal-banner-title">
                {t("restaurantbanner.title1")} <br />
                <span>{t("restaurantbanner.title2")}</span>
              </h1>

              <p className="mahal-banner-desc">
                {t("restaurantbanner.desc")}
              </p>

              <div className="mahal-btn-group mt-4">
                <Link to="/Registration" className="mahal-btn-primary">
                  {t("restaurantbanner.cta")}
                </Link>
              </div>

            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;